import React from "react";
import { getBrandReturnAppLiveUrl } from "~/cores/appCore";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";
import styles from "./ReturnAppLink.module.scss";
import { PrettyCopyBox } from "../copyText/PrettyCopyBox.jsx";

export default function ReturnAppLink({
    appProps,
    style,
    linkWrapperClassName,
    tooltipContent = "You should link this to your customers so they can start making returns",
    linkClassName,
    text = getBrandReturnAppLiveUrl(appProps),
}) {
    return (
        <TurnrTooltip style={{ ...style, height: "100%" }} anchorStyle={{ height: "100%" }} title={"Return portal URL"} content={tooltipContent} placement={"bottom"}>
            <div className={linkWrapperClassName}>
                <a target="_blank" className={linkClassName} href={getBrandReturnAppLiveUrl(appProps)} rel="noreferrer">
                    <b>{text}</b>
                </a>
            </div>
        </TurnrTooltip>
    );
}

export function ReturnAppLinkWithCopy({ appProps, tooltipContent, fullWidth }) {
    return (
        <PrettyCopyBox
            fullWidth={fullWidth}
            text={<ReturnAppLink appProps={appProps} linkWrapperClassName={styles["link-text-wrapper"]} linkClassName={styles["link-text"]} tooltipContent={tooltipContent} />}
            copyText={getBrandReturnAppLiveUrl(appProps)}
            copyHoverText={"Copy return page url"}
        />
    );
}
